import React, { useState } from 'react';
import GetMonths from '../Dropdowns/getMonths';
import GetYears from '../Dropdowns/getYears';
 import FPS_Stock_details from './FPS_Stock_details'
import GetDistricts from'../Dropdowns/getDistricts';
// import GetFpsId from'../Dropdowns/getFpsId';
import GetAfsoo from "../Dropdowns/getAfsoo";
 import GetFpssId from "../Dropdowns/getFpssid";




const Stock_Register_Int = ({ heading }) => {
    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true); // Manage loading state
     const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [selectedDist, setSelectedDist] = useState('');
    const [loadingFpsId, setLoadingFpsId] = useState(false);
      const [selectedAfso, setSelectedAfso] = useState("");
        const [loadingAfso, setLoadingAfso] = useState(false);
      
    
    
    const handleDistrictChange = (dist_code) => {
        setSelectedDist(dist_code);
       };
    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };





//       // ✅ Handle district change
//   const handleDistrictChange = (dist_code) => {
//     setSelectedDist(dist_code);
//     setSelectedAfso(""); // Reset AFSO and FPS when district changes
//   };

  // ✅ Handle AFSO change
  const handleAfsoChange = (afso_code) => {
    setSelectedAfso(afso_code);
  };
    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const dist_code = document.getElementById('dist_code').value;
        const fps_id = document.getElementById('fps_id').value;

        if (!month || month == 0 || month == null || month == '') {
            alert('Please select Month');
        } else if (!year || year == 0 || year == null || year == '') {
            alert('Please select Year');
        } else if (!dist_code || dist_code == 0 || dist_code == null || dist_code == '') {
            alert('Please select District');
        }
      else if (!selectedAfso || selectedAfso == 0 || selectedAfso == null || selectedAfso == '') {
      alert(" Please select an AFSO.");
    
        }else if (!fps_id ||  fps_id == 0 || fps_id == null || fps_id.trim == '') {
            alert('Please select a valid Fps Id');
        } else {
            setRenderContent(null);
            setTimeout(() => {
                setRenderContent(
                    <FPS_Stock_details
                        month={month}
                        year={year}
                        dist_code = {dist_code}
                        fps_id={fps_id}
                        heading={heading}
                    />
                );
            }, 0);
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={10}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleLoadingChange} /></td>
                                    <td>District</td>
                  <td>
                    <GetDistricts
                      onLoadingChange={setLoadingDistricts}
                      onChange={handleDistrictChange}
                    />
                  </td>


                       <td>AFSO</td>
                <td>
                  {selectedDist ? (
                    <GetAfsoo
                      dist_code={selectedDist}
                      onLoadingChange={setLoadingAfso}
                      onChange={handleAfsoChange}
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>


                     <td>FPS</td>
                <td>
                  {selectedAfso ? (
                    <GetFpssId
                      dist_code={selectedDist}
                      afso_code={selectedAfso}
                      onLoadingChange={setLoadingFpsId}
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>
                                </tr>
                                <tr>
                                    <td colSpan={10} align="center">
                                        <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Stock_Register_Int;
